import {Event} from './types';
import TpClient from './index';
import {getItem, setItem} from './cookies';
import {short} from './uuid';

const isDev = [
    'dev',
    'local',
].some(hostChunk => location.hostname.indexOf(hostChunk) === 0);

const client = new TpClient({
    endpoint: `https://${isDev ? 'dev' : 'www'}.finn.no/t/api/v1/collect`,
});

const COOKIE_NAME = 'tp-sid';
const THIRTY_MINUTES_IN_SECONDS = 30 * 60;

function refreshSessionCookie() {
    setItem(COOKIE_NAME, getItem(COOKIE_NAME) || short(), THIRTY_MINUTES_IN_SECONDS, '/', '.finn.no');
}

const DATA_AUTO_TRACK = 'data-auto-track-page';
const DATA_APP_NAME = 'data-application-name';

function getAttributeValue(attributeName: string) {
    try {
        let attributeValue;
        if (document.currentScript) {
            attributeValue = document.currentScript.getAttribute(attributeName);
        }
        if (!attributeValue) {
            const el = document.querySelector(`[${attributeName}]`);
            if (el) {
                attributeValue = el.getAttribute(attributeName);
            }
        }
        if (attributeValue) {
            return attributeValue;
        }
    } catch (e) {
        // ignore
    }
}

function autoTrack() {
    refreshSessionCookie();
    const payload: Event = {};

    if (location.search &&
        location.search.indexOf('starttracing') > -1

    ) {
        const id = client.enableTraceId();
        alert(`Trace id will be: ${id}`);
    }

    const applicationName = getAttributeValue(DATA_APP_NAME);
    if (applicationName) {
        client.setApplication(applicationName);
    }

    const autoTrackAttribute = getAttributeValue(DATA_AUTO_TRACK);
    const shouldAutoTrack = !(autoTrackAttribute === 'false');
    if (shouldAutoTrack) {
        setTimeout(() => {
            client.trackPage(payload);
        }, 0);
    }
}

autoTrack();

export default client;
